<template>
	<button
		@click="scrollToTop"
		class="fixed bottom-8 right-8 p-3 rounded-full bg-black/80 backdrop-blur-sm text-white shadow-lg transition-all duration-300 hover:bg-black/90 z-50"
		:class="{
			'translate-y-20 opacity-0': !isVisible,
			'translate-y-0 opacity-100': isVisible,
		}"
		aria-label="Back to top"
	>
		<svg
			class="w-6 h-6"
			fill="none"
			stroke="currentColor"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="2"
				d="M5 10l7-7m0 0l7 7m-7-7v18"
			></path>
		</svg>
	</button>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const isVisible = ref(false);
const scrollThreshold = 300; // Show button after scrolling 300px

const checkScroll = () => {
	isVisible.value = window.scrollY > scrollThreshold;
};

const scrollToTop = () => {
	window.scrollTo({
		top: 0,
		behavior: "smooth",
	});
};

// Add scroll event listener
onMounted(() => {
	window.addEventListener("scroll", checkScroll);
});

// Clean up
onUnmounted(() => {
	window.removeEventListener("scroll", checkScroll);
});
</script>

<style scoped>
button {
	transition: transform 0.3s ease, opacity 0.3s ease, background-color 0.3s ease;
}

button:hover svg {
	transform: translateY(-2px);
}

svg {
	transition: transform 0.2s ease;
}
</style>
